'use strict';

var processInclude = require('base:util');

$(document).ready(function () {
    if ($('#rx-container').attr('data-current-step') === '0') {
        processInclude(require('rxForm/rxVoucherForm'));
    } else {
        processInclude(require('rxForm/rxForm'));
    }
});
